import { call, put } from 'redux-saga/effects';
import { photoCaptureIntelligentPostPrtcDetailsFailureAction, photoCaptureIntelligentPostPrtcDetailsSuccessAction } from '../actions';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
import { IntelligentPhotoCapturePrtcDetailsService } from '../services';
import { photoCaptureUploadDamageAttachmentsSaga } from './photoCaptureUploadDamageAttachmentsSaga';
export function* photoCaptureIntelligentPrtcDetailsSaga(action) {
    try {
        const prtcDetailsService = new IntelligentPhotoCapturePrtcDetailsService();
        const response = yield call([prtcDetailsService, prtcDetailsService.postPrtcDetails], action.payload.request);
        yield put(photoCaptureIntelligentPostPrtcDetailsSuccessAction(response));
        yield call(photoCaptureUploadDamageAttachmentsSaga);
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentPostPrtcDetailsFailureAction(errorMessage));
        yield call(photoCaptureUploadDamageAttachmentsSaga);
    }
}
//# sourceMappingURL=intelligentPhotoCapturePrtcDetailsSaga.js.map